import { render, staticRenderFns } from "./Reagent.vue?vue&type=template&id=626220f4&scoped=true"
import script from "./Reagent.vue?vue&type=script&lang=js"
export * from "./Reagent.vue?vue&type=script&lang=js"
import style0 from "./Reagent.vue?vue&type=style&index=0&id=626220f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626220f4",
  null
  
)

export default component.exports